import { captureCustomException } from 'App/Services/ErrorTracking/captureCustomException';
import OneSignal from 'react-onesignal';

import { ONESIGNAL_REQUEST_PERMISSION_ERROR } from './constants';

/**
 * Requests the browser notification permission through OneSignal.
 *
 * @returns {Promise<NotificationPermission | undefined>}
 */
export const requestPushPermission = async () => {
    try {
        await OneSignal.Notifications.requestPermission();

        return Notification.permission;
    } catch (error) {
        captureCustomException(error, ONESIGNAL_REQUEST_PERMISSION_ERROR);
    }
};
